<template>
  <div class="addprint">
    <p class="title">选择尺寸</p>
    <div class="flexwrap">
      <div class="flexitem" v-for="(item,index) in rule" :key="item.id" :class="{active:index===selindex}" @click="selindexFn(index)">
        <div class="fit">{{item.name}}</div>
        <div class="fib">{{item.width}} × {{item.height}} mm</div>
      </div>
    </div>
    <p class="title">冲印版数</p>
    <cell :cellName="`冲印版数${rule[selindex]&&rule[selindex].total?'（1版'+rule[selindex].total+'小张）：':''}`">
      <div slot="value" id="num-selector-container">
        <div class="num-selector">
          <div class="num-ctrl" @click="calcNum(-1)">-</div>
          <div class="num">{{num}}</div>
          <div class="num-ctrl" @click="calcNum(1)">+</div>
        </div>
        <div>版</div>
      </div>
    </cell>
    <p class="title">选择颜色</p>
    <div class="clrwrap" v-show="url">
        <img :src="url" class="previewimg">
        <p class="pretxt">预览图</p>
        <color-sel :coloridx="coloridx" :color="rule[selindex]&&rule[selindex].colors" @onSetidx="onSetidx"></color-sel>
    </div>
    <div class="btn" @click="addFn">加印</div>
  </div>
</template>
<script>
import Cell from "@/components/Form/Cell";
import colorSel from "@/components/colorSel";
import {Toast} from 'mint-ui'
import {mapActions,mapMutations} from "vuex";
import {createPrint} from "@/utils/utils";
export default {
  components: {
    Cell,colorSel
  },
  data(){
      return {
          coloridx:-1,
          rule:[],
          selindex:0,
          num:1,
          url:''
      }
  },
  created(){
    this.inimeobj()
    this.handledata()
  },
  methods:{
    ...mapMutations(['ADDGROUPLIST','SETRULECOLOR']),
    ...mapActions(['getSpecs','getAutoImage']),
    onSetidx(idx){
      if(this.coloridx===idx){
        return
      }
      this.coloridx=idx
      this.$root.$emit('toggleIndicator',true)
      return this.makecanvas().then(res=>{
        this.url=res
        this.$root.$emit('toggleIndicator',false)
      }).catch(err=>{
        this.$root.$emit('toggleIndicator',false)
      })
    },
    inimeobj(){
      this.meobj={}
    },
    addFn(){
      if(this.selindex<0){
        return Toast('请选择尺寸')
      }
      if(this.coloridx<0){
        return Toast('请选择颜色')
      }
      if(!this.url){
        return Toast('图片没有制作出来呢，请重新操作')
      }
      let {colors,id,total,name} = this.rule[this.selindex]
      let {singlePrice} = this.$route.params
      let obj = {
        id,
        printQty:this.num,
        sheets_number:total,
        colorIdx:this.coloridx,
        colorName:colors[this.coloridx].color_cn,
        singlePrice,
        spec_name:name,
        image_url:this.url
      }
      this.ADDGROUPLIST(obj)
      this.$router.go(-1)
    },
    handledata(){
      this.$root.$emit('toggleIndicator',true)
      this.getData().then(res=>{
        return this.getAuto(0)
      }).then(res=>{
        this.$root.$emit('toggleIndicator',false)
      }).catch(err=>{
        this.$root.$emit('toggleIndicator',false)
      })
    },
    selindexFn(idx){
      if(idx!==undefined&&this.selindex===idx){
        return
      }
      this.getAuto(idx)
    },
    tentotwo(num){
				return num.toString(16).padStart(6,0)
			},
    makecanvas(){
      let obj = this.meobj.paibanInfo
      let {start_color,enc_color} = this.rule[this.selindex].colors[this.coloridx]
      let colors = ['#'+this.tentotwo(start_color),'#'+this.tentotwo(enc_color)]
       
      return createPrint(obj,colors,'请使用六寸相纸打印')
    },
    // 初始化 增值服务-> 换正装
    judgeIsClothes() {
      // console.log("看下环境", this.printInfo);
      console.log("我要炸拉前部11", this.$route.query.data);
      // 如果没有需要的 JSON 数据，退出初始化
      
      if (!this.$route.query.data) return false;
      // console.log(
      //   "是否是ios",
      //   /iphone|ipad|ipod|ios/i.test(window.navigator.userAgent.toLowerCase())
      // );
      let qd =
        (splitPayment(this.printInfo.payment) === "qq" || splitPayment(this.printInfo.payment) === "kuaishou") &&
        /iphone|ipad|ipod|ios/i.test(window.navigator.userAgent.toLowerCase())
          ? decodeURIComponent(this.$route.query.data)
          : this.$route.query.data;
      let data = JSON.parse(qd);
      // console.log("我要炸拉", data);
      // 如果没有换装数据，退出初始化
      if (typeof data["formal"] !== "object") return false;

      // 初始化一写 flag, 显示选择框
      return true;

     
    },
    getAuto(idx){
      this.$root.$emit('toggleIndicator',true)
      let {extra:{key},truing_param,data} = this.$store.getters.getQueryInfo;

      console.log('getAuto:::,',truing_param)
      console.log('getAuto:::formal,',data)
      let truing_param_obj = truing_param ? JSON.parse(truing_param) :{}
      let data_obj = data ? JSON.parse(data) : {}
      let obj = {
        image_key:key,
        is_fine:!!truing_param_obj.truing,
        is_clothes:typeof data_obj["formal"] === "object"
      }
      obj.spec_id=this.rule[idx].id
      return this.getAutoImage(obj).then(res=>{
        this.selindex=idx
        this.coloridx=0
        this.num=1
        this.meobj.paibanInfo=res
        console.log("res:::",res)
        return this.makecanvas()
      }).then(res=>{
        this.$root.$emit('toggleIndicator',false)
        this.url = res
      }).catch(err=>{
        console.log("err:::",err)
        Toast(err)
        this.$root.$emit('toggleIndicator',false)
      })
    },
    calcNum(count){
      let num = this.num
      if (num >= 20 && +count > 0) return Toast('不能再多啦！');
      if (num <= 1 && +count < 0) return Toast('亲，不能再少啦！');
      this.num=num+count
    },
    getData(){
      let {extra:{id}} = this.$store.getters.getQueryInfo
      return this.getSpecs(id).then(res=>{
        this.rule=res
        return res[0].id
      }).catch(err=>{
        Toast('数据获取失败，请重新操作')
      })
    }
  }
};
</script>
<style scoped>
.addprint {
  min-height: 100vh;
  box-sizing: border-box;
  padding: 16px 16px 30px;
}
.title {
  font-size: 16px;
  color: #363636;
  font-weight: bold;
  margin-bottom: 14px;
}
.flexwrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 4px;
}
.flexitem {
  width: 162px;
  height: 72px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 0 22px;
  font-size: 12px;
  color: #6e6e6e;
  background-color: #fff;
  border-radius: 5px;
  margin-bottom: 12px;
  border:1px solid transparent;
}
.fit {
  font-weight: bold;
  font-size: 14px;
  text-overflow: ellipsis;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 8px;
  line-height:1.25em;
}
.fib {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
.active {
  border: 1px solid;
  color: #465ae0;
}
#num-selector-container {
  display: flex;
  align-items: center;
}
.num-selector {
  display: flex;
  align-items: center;
  margin-right: 8px;
}
.num-ctrl {
  width: 14px;
  height: 16px;
  border: 1px solid rgba(151, 151, 151, 0.4);
  border-radius: 1px;
  line-height: 14px;
  text-align: center;
}

.num {
  width: 30px;
  text-align: center;
}
.cell{
    border-bottom: none;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 16px;
}
.clrwrap{
    background-color: #fff;
    border-radius: 5px;
    box-sizing: border-box;
    padding:26px;
}
.previewimg{
    width:157px;
    height:108px;
    box-shadow: 0 2px 4px rgba(172, 200, 255, 0.6);
    display: block;
    margin:0 auto 8px;
}
.pretxt{
    margin-bottom:24px;
    font-size: 12px;
    color:rgba(54, 54, 54, .5);
    text-align: center;
}
.btn{
    height: 44px;
    border-radius: 5px;
    text-align: center;
    line-height: 44px;
    font-size: 16px;
    color:#fff;
    background-color: #465AE0;
    margin-top: 23px;
}

</style>